export const DD_ACTIONS = {
    DISPLAY_LOGIN_MODAL_STANDARD: 'rla_forms_standard_LoginModal_is_displayed',
    DISPLAY_REGISTRATION_MODAL_STANDARD: 'rla_forms_standard_RegistrationModal_is_displayed',
    DISPLAY_LOGIN_REGISTRATION_MODAL_TWO_STEP: 'rla_forms_twoStep_LoginRegistrationModal_is_displayed',
};
export const addDataDogAction = (actionName) => {
    if (window?.DD_RUM &&
        window.DD_RUM.addAction &&
        typeof window.DD_RUM.addAction === 'function') {
        window.DD_RUM.addAction(actionName);
    }
};
//# sourceMappingURL=datadog.js.map